import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import Loading from "../Loading/Loading";
import apiRequests from "../axios/config/config";

import toast from "react-hot-toast";

import webLogo from "../../assets/image/webLogo.png";
import user from "../../assets/image/user.svg";
import calling from "../../assets/image/calling.svg";
import calendar from "../../assets/image/calendar.svg";
import keyIcon from "../../assets/image/keyIcon.png";
import loginpic from "../../assets/image/loginPic.svg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { MdAlternateEmail, MdErrorOutline } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { BsImage } from "react-icons/bs";
import MapLocationPicker from "../MapLocationPicker/MapLocationPicker";

export function Register() {
  const navigate = useNavigate();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [openImmigration, setOpenImmigration] = useState(false);
  const [openTrType, setOpenTrType] = useState(false);
  const [errors, setErrors] = useState({});
  const [type, setType] = useState(null);
  const [step, setStep] = useState(1);
  const immigrationDocRef = useRef(null);
  const [immigrationStatus, setImmigrationStatus] = useState({});
  const [uploadingImage, setUploadingImage] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [userInfo, setUserInfo] = useState({
    userName: "",
    email: "",
    password: "",
    confirmPass: "",
    mobile: "",
    birthday: "",
    immigrationStatus: "",
    trType: "",
    immigrationDocument: null,
    bankAccountNumber: "",
    expire: "",
    lat: null,
    long: null,
  });

  function validateStep1() {
    const newErrors = {};
    const step1Fields = [
      "userName",
      "email",
      "mobile",
      "birthday",
      "password",
      "confirmPass",
    ];

    step1Fields.forEach((key) => {
      const value = userInfo[key];
      if (key === "birthday") {
        if (!value) newErrors[key] = true;
      } else {
        if (!value?.trim()) newErrors[key] = true;
      }
    });

    if (userInfo.password && userInfo.password.length < 6) {
      newErrors.password = true;
    }

    if (
      userInfo.confirmPass &&
      userInfo.password &&
      userInfo.confirmPass !== userInfo.password
    ) {
      newErrors.confirmPass = true;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  function validateStep2() {
    const newErrors = {};

    if (!userInfo.immigrationStatus) newErrors.immigrationStatus = true;

    if (userInfo.immigrationStatus === "temporary" && !userInfo.trType) {
      newErrors.trType = true;
    }

    if (!userInfo.immigrationDocument) newErrors.immigrationDocument = true;

    if (!userInfo.lat || !userInfo.long) {
      toast.error("Please select your location on the map");
      return false;
    }

    if (!/^\d{16}$/.test(userInfo.bankAccountNumber)) {
      toast.error("Bank account number must be exactly 16 digits");
      return;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  async function CreateUser(e) {
    e?.preventDefault();

    if (loadingAdd) return;

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{6,}$/;

    if (!validateStep2()) {
      toast.error("Please fill in all required fields");
      return;
    }

    if (userInfo.password && !passwordRegex.test(userInfo.password)) {
      toast.error("Password does not meet the requirements");
      return;
    }

    const endpoint =
      type === "Seller"
        ? "/seller/v1/register-seller"
        : "/seller/v1/register-chef";

    const payload = {
      ...userInfo,

      immigrationStatus:
        userInfo.immigrationStatus === "temporary"
          ? userInfo.trType
          : userInfo.immigrationStatus,
    };

    delete payload.trType;

    try {
      setLoadingAdd(true);

      await apiRequests.post(endpoint, payload);
      toast.success("Account created successfully!");

      navigate("/login");
    } catch (err) {
      toast.error("Error happened");
    } finally {
      setLoadingAdd(false);
    }
  }

  useEffect(() => {
    const fetchImmigrationStatus = async () => {
      setLoadingStatus(true);
      try {
        const res = await apiRequests.get("/seller/v1/get-ImmigrationStatus");
        setImmigrationStatus(res.data.data || {});
      } catch (err) {
        console.log(err);
        toast.error("Failed to load immigration statuses");
      } finally {
        setLoadingStatus(false);
      }
    };
    fetchImmigrationStatus();
  }, []);

  const uploadImage = async (file) => {
    setUploadingImage(true);

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await apiRequests.post("/file/v1/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.success) {
        setUserInfo((prev) => ({
          ...prev,
          immigrationDocument: res.data.message._id,
        }));

        toast.success("Document uploaded successfully");
      }
    } catch (error) {
      toast.error("Failed to upload document");
    } finally {
      setUploadingImage(false);
    }
  };

  const trTypeList = Object.values(immigrationStatus.Temporary || {});

  const statusesWithoutExpire = [
    "protected_person",
    "permanent_resident",
    "canadian_citizen",
  ];

  const selectedImmigrationStatus =
    userInfo.immigrationStatus === "temporary"
      ? userInfo.trType
      : userInfo.immigrationStatus;

  const shouldShowExpireDate =
    selectedImmigrationStatus &&
    !statusesWithoutExpire.includes(selectedImmigrationStatus);

  const mainStatusList = [
    { key: "TEMPORARY", value: "temporary", label: "Temporary Resident" },
    ...Object.entries(immigrationStatus)
      .filter(([key]) => key !== "Temporary")
      .map(([, val]) => val),
  ];

  return (
    <div>
      <div className="grid grid-cols-2 md:flex md:min-h-screen md:justify-center md:items-center ">
        {" "}
        <div className="col-span-1 h-full md:hidden flex flex-col items-center bg-[#051F33] gap-6">
          <div className="mt-12">
            <h3 className="text-white font-inter flex justify-center -mb-2">
              Welcome to
            </h3>
            <div className="flex flex-row gap-4">
              <img className="w-13 h-20" alt="webicon" src={webLogo} />
              <h1 className="text-white flex font-asap items-center text-[40px] tracking-wide">
                clan
                <span className="text-[#47B26E] font-asap font-bold text-4xl relative -bottom-3">
                  S
                </span>
                mart
              </h1>
            </div>
          </div>
          <img src={loginpic} className="w-30 h-90" alt="loginpic" />
          <div>
            <p className="text-white font-inter text-center">
              The trusted marketplace for <br />
              customers, stores, and home cooks
            </p>
          </div>
        </div>
        <div className="flex justify-center min-h-screen items-start py-16 px-5 col-span-1 md:col-span-2 md:w-full bg-[#F0E8E4]">
          {type === null ? (
            <div className=" font-inter border-2 overflow-hidden rounded-2xl shadow-2xl bg-white py-5 px-6 w-[70%] md:w-full items-center justify-center flex flex-col gap-6">
              <div className="flex flex-col w-full justify-center items-center gap-12">
                <span className="text-2xl font-asap mt-5">
                  select your store type
                </span>
                <div className="flex flex-col justify-center gap-5">
                  <div className="flex flex-col gap-2">
                    <button
                      className="p-2 rounded-lg transition-colors bg-[#051F33] text-white hover:bg-green-400"
                      onClick={() => setType("Seller")}
                    >
                      Grocery Store
                    </button>
                    <span className="text-gray-500 text-md font-asap">
                      A chance to sell best quality grocery items
                    </span>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button
                      className="p-2 rounded-lg transition-colors bg-[#051F33] text-white hover:bg-orange-400"
                      onClick={() => setType("Chef")}
                    >
                      Homemade Foods
                    </button>
                    <span className="text-gray-500 text-md font-asap">
                      Grace your costumers with deliciously made homemade dishes
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="text-black font-inter border-2 overflow-hidden rounded-2xl shadow-2xl bg-white py-5 px-6 w-[60%] md:w-full items-center justify-center flex flex-col gap-5">
                <div className="grid grid-cols-5 w-full">
                  <div className="col-span-1 flex justify-start">
                    <button
                      className="rounded-lg p-1 text-sm text-gray-500 flex justify-center items-center "
                      onClick={() => (step === 1 ? setType(null) : setStep(1))}
                    >
                      <FaChevronLeft className="text-xs" />
                    </button>
                  </div>
                  <div className="col-span-3 flex flex-col items-center justify-center ">
                    <p className="text-2xl font-semibold">Sign up</p>
                  </div>
                  <div className="col-span-1"></div>
                </div>

                {step === 1 && (
                  <>
                    <div className="flex flex-col justify-start gap-2 w-full">
                      {/* <div
                        className={`border ${errors.fullName ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        {" "}
                        <img className="w-5 h-5" alt="usericon" src={user} />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.fullName}
                          type="text"
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              fullName: e.target.value,
                            })
                          }
                          placeholder="Full name"
                        />
                      </div> */}
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.userName ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        {" "}
                        <img className="w-5 h-5" alt="usericon" src={user} />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.userName}
                          type="text"
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              userName: e.target.value,
                            })
                          }
                          placeholder="User name"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.mobile ? "border-red-500 " : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        <img
                          className="w-5 h-5"
                          alt="callingicon"
                          src={calling}
                        />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.mobile}
                          type="tel"
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, mobile: e.target.value })
                          }
                          placeholder="Phone number"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.email ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        <MdAlternateEmail className="w-5 h-5 text-firstColor-shade1" />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.email}
                          type="email"
                          onChange={(e) =>
                            setUserInfo({ ...userInfo, email: e.target.value })
                          }
                          placeholder="E-Mail"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.birthday ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        <img
                          className="w-5 h-5"
                          alt="calendaricon"
                          src={calendar}
                        />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.birthday}
                          type="date"
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              birthday: e.target.value,
                            })
                          }
                          placeholder="Date of birth"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.password ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2 `}
                      >
                        <img className="w-5 h-5" alt="keyicon" src={keyIcon} />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.password}
                          type={showPassword ? "text" : "password"}
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              password: e.target.value,
                            })
                          }
                          placeholder="Password"
                        />
                        <div onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? (
                            <AiOutlineEyeInvisible className="w-6 h-6 text-gray-500 " />
                          ) : (
                            <AiOutlineEye className="w-6 h-6 text-gray-500 " />
                          )}
                        </div>
                      </div>
                      <div className=" text-xs ml-2">
                        <p
                          className={
                            /[!@#$%^&*,.?"|]/.test(userInfo.password)
                              ? "text-green-600"
                              : "text-gray-400"
                          }
                        >
                          At least one special character
                        </p>

                        <p
                          className={
                            /[A-Z]/.test(userInfo.password)
                              ? "text-green-600"
                              : "text-gray-400"
                          }
                        >
                          At least one uppercase letter
                        </p>

                        <p
                          className={
                            /\d/.test(userInfo.password)
                              ? "text-green-600"
                              : "text-gray-400"
                          }
                        >
                          At least one number
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.confirmPass ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        <img className="w-5 h-5" alt="keyicon" src={keyIcon} />
                        <input
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.confirmPass}
                          type={showConfirmPassword ? "text" : "password"}
                          onChange={(e) =>
                            setUserInfo({
                              ...userInfo,
                              confirmPass: e.target.value,
                            })
                          }
                          placeholder="Confirm password"
                        />
                        <div
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <AiOutlineEyeInvisible className="w-6 h-6 text-gray-500 " />
                          ) : (
                            <AiOutlineEye className="w-6 h-6 text-gray-500 " />
                          )}
                        </div>
                      </div>
                    </div>

                    <button
                      className="bg-[#051F33] w-full flex justify-center text-white px-5 py-2 rounded-lg "
                      onClick={() => {
                        if (validateStep1()) setStep(2);
                      }}
                    >
                      Next
                    </button>
                  </>
                )}

                {step === 2 && (
                  <>
                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div className="relative w-full">
                        <button
                          type="button"
                          onClick={() => setOpenImmigration((prev) => !prev)}
                          className={`border ${errors.immigrationStatus ? "border-red-500" : "border-neutral-400"} w-full bg-white rounded-lg px-5 py-2 flex justify-between items-center`}
                        >
                          <span
                            className={
                              userInfo.immigrationStatus
                                ? "text-black"
                                : "text-gray-500"
                            }
                          >
                            {loadingStatus
                              ? "Loading..."
                              : mainStatusList.find(
                                  (opt) =>
                                    opt.value === userInfo.immigrationStatus,
                                )?.label || "Select immigration status"}
                          </span>
                          <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                        </button>

                        {openImmigration && (
                          <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30">
                            {mainStatusList.map((option) => (
                              <li
                                key={option.key}
                                onClick={() => {
                                  setUserInfo({
                                    ...userInfo,
                                    immigrationStatus: option.value,
                                    trType:
                                      option.value === "temporary"
                                        ? userInfo.trType
                                        : "",
                                    expire: "",
                                  });
                                  setOpenImmigration(false);
                                }}
                                className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    {userInfo.immigrationStatus === "temporary" && (
                      <div className="flex flex-col justify-start gap-2 w-full">
                        <div className="relative w-full">
                          <button
                            type="button"
                            onClick={() => setOpenTrType((prev) => !prev)}
                            className={`border ${errors.trType ? "border-red-500" : "border-neutral-400"} w-full bg-white rounded-lg px-5 py-2 flex justify-between items-center`}
                          >
                            <span
                              className={
                                userInfo.trType ? "text-black" : "text-gray-500"
                              }
                            >
                              {trTypeList.find(
                                (opt) => opt.value === userInfo.trType,
                              )?.label || "Select TR type"}
                            </span>
                            <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                          </button>

                          {openTrType && (
                            <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30">
                              {trTypeList.map((option) => (
                                <li
                                  key={option.key}
                                  onClick={() => {
                                    setUserInfo({
                                      ...userInfo,
                                      trType: option.value,
                                      expire: "",
                                    });
                                    setOpenTrType(false);
                                  }}
                                  className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                                >
                                  {option.label}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    )}

                    {shouldShowExpireDate && (
                      <div className="flex flex-col justify-start gap-2 w-full">
                        <div
                          className={`border ${
                            errors.expire
                              ? "border-red-500"
                              : "border-neutral-400"
                          } flex items-center rounded-lg justify-between px-5 py-2`}
                        >
                          <img
                            className="w-5 h-5"
                            alt="calendaricon"
                            src={calendar}
                          />

                          <input
                            className="pl-2 outline-0 w-full placeholder:text-gray-500"
                            type="date"
                            value={userInfo.expire}
                            onChange={(e) =>
                              setUserInfo({
                                ...userInfo,
                                expire: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        onClick={() => immigrationDocRef.current.click()}
                        className="w-full h-32 rounded-lg border-2 border-dashed border-neutral-400
                        flex flex-col items-center justify-center cursor-pointer text-neutral-400"
                      >
                        <BsImage className="text-3xl mb-2" />
                        <span>
                          {documentName || "Upload immigration document"}
                        </span>
                        <input
                          ref={immigrationDocRef}
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files[0];

                            if (file) {
                              setDocumentName(file.name);
                              uploadImage(file);
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <div
                        className={`border ${errors.bankAccountNumber ? "border-red-500" : "border-neutral-400"} flex items-center rounded-lg justify-between px-5 py-2`}
                      >
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={16}
                          className="pl-2 outline-0 w-full placeholder:text-gray-500 outline-none focus:outline-none focus:ring-0"
                          value={userInfo.bankAccountNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            setUserInfo({
                              ...userInfo,
                              bankAccountNumber: value,
                            });
                          }}
                          placeholder="Bank account number"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col justify-start gap-2 w-full">
                      <label className="text-sm text-gray-600 ml-1">
                        Select your location
                      </label>
                      <MapLocationPicker
                        latitude={userInfo.lat}
                        longitude={userInfo.long}
                        onChange={(lat, long) =>
                          setUserInfo((prev) => ({ ...prev, lat, long }))
                        }
                        height={150}
                      />
                    </div>

                    <button
                      onClick={CreateUser}
                      disabled={loadingAdd}
                      className={`bg-[#051F33] w-full flex justify-center text-white px-5 py-2 rounded-lg ${
                        loadingAdd ? "opacity-60 cursor-not-allowed" : ""
                      }`}
                    >
                      {loadingAdd ? (
                        <Loading textColor={"white-0"} />
                      ) : (
                        <>Sign up</>
                      )}
                    </button>
                  </>
                )}
                <div className="flex justify-center">
                  <a
                    href="/"
                    className="text-blue-500 hover:text-blue-700  cursor-pointer"
                  >
                    Return to login
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
